/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number to Words — Spell Numbers in English | Toolverse`)
};

const es_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número a Palabras — Deletrea Números en Inglés | Toolverse`)
};

const de_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen in Worte — Zahlen auf Englisch ausschreiben | Toolverse`)
};

const nl_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getal naar Woorden — Schrijf Getallen in het Engels | Toolverse`)
};

const fr_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombres en Lettres — Écrivez les nombres en français | Toolverse`)
};

const it_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da numeri a parole — Scrivi i numeri in inglese | Toolverse`)
};

const pt_br2_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números em Palavras — Escreva Números em Português | Toolverse`)
};

const pt_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números para Palavras — Escrever Números em Inglês | Toolverse`)
};

const ja_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字を単語に — Toolverse で英語で数字を綴る`)
};

const zh_nw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字转文字 — 用英文拼写数字 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_meta_title", locale)
	if (locale === "en") return en_nw_meta_title(inputs)
	if (locale === "es") return es_nw_meta_title(inputs)
	if (locale === "de") return de_nw_meta_title(inputs)
	if (locale === "nl") return nl_nw_meta_title(inputs)
	if (locale === "fr") return fr_nw_meta_title(inputs)
	if (locale === "it") return it_nw_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_nw_meta_title(inputs)
	if (locale === "pt") return pt_nw_meta_title(inputs)
	if (locale === "ja") return ja_nw_meta_title(inputs)
	return zh_nw_meta_title(inputs)
};